import { usePremiumIntent, useStandardIntent } from "@/components/user-context";

import { LoggedOutJsmFree } from "./free/logged-out-jsm-free";
import { LoggedOutJsmPremium } from "./premium/logged-out-jsm-premium";
import { LoggedOutJsmStandard } from "./standard/logged-out-jsm-standard";

export const LoggedOutJsm = () => {
    const isStandard = useStandardIntent();
    const isPremium = usePremiumIntent();

    if (isStandard) {
        return <LoggedOutJsmStandard />;
    }

    if (isPremium) {
        return <LoggedOutJsmPremium />;
    }

    return <LoggedOutJsmFree />;
};
